import { Group, Title, Menu, Button } from '@mantine/core';
import { IconRefresh, IconMenu2, IconLogout } from '@tabler/icons-react';
import { useIntl } from 'react-intl';
import { useClient } from '@contexts/ClientContext';

export const FolderMenu = ({ folderName }: { folderName: string }) => {
  const intl = useIntl();
  const { logout } = useClient();

  return (
    <Group justify="space-between" align="center">
      <Title order={5}>{intl.formatMessage({ id: 'files' })}</Title>

      <Menu
        position="left"
        withinPortal
        withArrow
        trigger="click"
        closeOnItemClick={true}
        transitionProps={{ exitDuration: 0 }}
      >
        <Menu.Target>
          <Button
            size="xs"
            variant="subtle"
            color="gray"
            p={5}
            aria-label="Menu"
          >
            <IconMenu2 size={20} />
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            leftSection={<IconRefresh size={16} />}
            onClick={() => {
              window.location.reload();
            }}
          >
            {intl.formatMessage({ id: 'refresh' })}
          </Menu.Item>
          <Menu.Item
            leftSection={<IconLogout size={16} />}
            onClick={() => {
              logout();
            }}
          >
            {intl.formatMessage({ id: 'logout' })}
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Group>
  );
};
